import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faUndo } from '@fortawesome/pro-light-svg-icons/faUndo';
import LinkButton from '../common/Buttons/LinkButton';

const SaveEditSwitcher = (props) => {
  const { inEditMode, onEditClick, onDiscardClick, onSaveClick } = props;
  const { buttons = [], icon, title, saveAction = 'button' } = props;
  const { save = null, edit = null, discard = null } = buttons;

  return (
    <h1>
      <span>
        <FontAwesomeIcon icon={icon} />
        &nbsp; {title}
      </span>
      {inEditMode ? (
        <Fragment>
          {discard && (
            <LinkButton className="discard-button" onClick={onDiscardClick} type="reset">
              <FontAwesomeIcon icon={faUndo} /> &nbsp; {discard}
            </LinkButton>
          )}
          <LinkButton className="edit-button" type={saveAction} onClick={saveAction === 'button' ? onSaveClick : null}>
            <FontAwesomeIcon icon={faCheck} /> &nbsp; {save}
          </LinkButton>
        </Fragment>
      ) : (
        <LinkButton className="edit-button" onClick={onEditClick}>
          <FontAwesomeIcon icon={faPencil} /> &nbsp; {edit}
        </LinkButton>
      )}
    </h1>
  );
};

export default SaveEditSwitcher;
